import { useMemo } from "react";

import useQuery from "../search/useQuery";
import QUERY_TAGS from "../search/queryTags";
import { normalizeSharedPage } from "../finance/financePage";
import { VOLATILE_STALE_TIME } from "../finance/financeCache";
import { ALL_PAGE_SIZE, fetchMyRatings } from "./reviewsService";
import { mapReviews } from "./reviewsMappers";

const useAllMyReviews = ({ enabled = true } = {}) => {
  const query = useQuery({
    key: enabled ? "reviews:mine:all" : null,
    tag: QUERY_TAGS.MY_RATINGS,
    staleTime: VOLATILE_STALE_TIME,
    enabled,
    fetcher: () => fetchMyRatings({ page: 1, pageSize: ALL_PAGE_SIZE }),
  });

  const items = useMemo(
    () => mapReviews(normalizeSharedPage(query.currentData).items),
    [query.currentData]
  );

  return {
    items,
    isLoading: query.enabled && query.currentData === undefined && !query.isError,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};

export default useAllMyReviews;
